import { firestoreDateParser, MarketplaceOrder } from '@pedix-workspace/utils';

export const parseMarketplaceOrderDates = (
  marketplaceOrder: MarketplaceOrder | undefined,
): MarketplaceOrder | undefined => {
  if (!marketplaceOrder) {
    return undefined;
  }

  const { preparationAdjustment, preparationRange, notified } = marketplaceOrder;

  return {
    ...marketplaceOrder,
    reviewReasons: marketplaceOrder.reviewReasons ?? [],
    pickupAt: firestoreDateParser(marketplaceOrder.pickupAt) ?? null,
    acceptBefore: firestoreDateParser(marketplaceOrder.acceptBefore) ?? null,
    riderArrivedAt: firestoreDateParser(marketplaceOrder.riderArrivedAt) ?? null,
    preparationRange: preparationRange
      ? {
          ...preparationRange,
          minPickupAt:
            firestoreDateParser(preparationRange.minPickupAt) ?? preparationRange.minPickupAt,
          maxPickupAt:
            firestoreDateParser(preparationRange.maxPickupAt) ?? preparationRange.maxPickupAt,
        }
      : null,
    preparationAdjustment: preparationAdjustment
      ? {
          ...preparationAdjustment,
          pickupAt:
            firestoreDateParser(preparationAdjustment.pickupAt) ?? preparationAdjustment.pickupAt,
        }
      : null,
    notified: {
      accepted: notified?.accepted ?? false,
      rejected: notified?.rejected ?? false,
      prepared: notified?.prepared ?? false,
      pickedUp: notified?.pickedUp ?? false,
      preparationAdjustmentAt: firestoreDateParser(notified?.preparationAdjustmentAt) ?? null,
    },
  };
};
